<template>
  <v-container grid-list-lg>
    <v-layout row wrap>
      <p v-if="quoteNo != ''"><strong>The Quote has successfully been cloned.</strong><br /><br />Your cloned quote reference is: <strong>{{ quoteNo }}</strong></p>
      <v-flex v-if="quoteNo == ''" lg6 class="userInfo">
        <label class="blackLabel">Store</label>
        <v-select @input="fncCheckFields()" :items="branchList" v-model="globalModalParams.quote_id"  placeholder="Store" class="dropdown" item-value="id" item-text="name" solo autocomplete></v-select>
      </v-flex>
      <v-flex v-if="quoteNo == ''" lg6 class="userInfo">
        <label class="blackLabel">Customer</label>
        <v-select @input="fncCheckFields()" :items="globalModalParams.users" v-model="globalModalParams.customer"  autocomplete placeholder="User" class="dropdown" item-value="userid" item-text="fullname" solo autocomplete></v-select>
      </v-flex>
      <v-flex v-if="quoteNo == ''" lg6 class="userInfo">
        <label class="blackLabel">Project</label>
        <v-select :items="projectList" v-model="globalModalParams.project"  autocomplete placeholder="Project" class="dropdown" item-value="id" item-text="name" solo autocomplete></v-select>
      </v-flex>
      <v-flex v-if="quoteNo == ''" lg6 class="userInfo">
        <label class="blackLabel">Company</label>
        <v-text-field v-model="globalModalParams.survey_company" solo single-line></v-text-field>
      </v-flex>
      <v-flex v-if="quoteNo == ''" lg6 class="userInfo">
        <label class="blackLabel">Starting Status</label>
        <v-select @input="fncCheckFields()" :items="filterStatus" v-model="globalModalParams.status"  autocomplete placeholder="Starting Status" class="dropdown" item-value="description" item-text="description" solo autocomplete></v-select>
      </v-flex>
      <div class="pl-4 pr-2 pb-4 buttonHolder">
        <div style="float: right">
          <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>
          <!--<v-btn color="success" class="text-xs-right" @click.stop="fncDownloadQuote">Download</v-btn>-->
          <v-btn v-if="quoteNo == ''" :disabled="canClone" color="success" class="text-xs-right" @click.stop="fncClone">Clone</v-btn>
        </div>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
import {mapGetters} from "vuex";
export default {
  name: "Modal_clone_quote",
  data () {
    return {
      filterStatus: [],
      canClone: true
    }
  },
  methods: {
    fncCheckFields() {

      if( this.globalModalParams.quote_id == '' || this.globalModalParams.customer == '' || this.globalModalParams.status == '' ) {
        this.canClone = true;
      }
      this.canClone = false;

    },
    fncHideModal() {
      // this.$store.commit('hideModal');
      window.location.reload();
    },
    fncClone()
    {
      this.$store.dispatch({
        type: 'fncCloneQuote',
        quote: this.globalModalParams.quoteData.quote,
        branch_id: this.globalModalParams.quote_id,
        customer : this.globalModalParams.customer,
        department : this.globalModalParams.departmentId,
        status : this.globalModalParams.status,
        company : this.globalModalParams.survey_company,
        project : this.globalModalParams.project
      })
    }
  },
  computed: {
    ...mapGetters([
      'branchList',
      'objAuthorize',
      'globalModalParams',
      'globalModalComponent',
      'statusList',
      'projectList',
      'quoteNo'
    ])
  },
  beforeMount() {
    this.$store.dispatch('fncPopulateProjectList');
    this.$store.dispatch('fncPopulateBranches');
  },
  mounted() {
    this.globalModalParams.status = '';
    this.filterStatus = [];
    /*if( this.globalModalParams.quoteData.total != '0' ) {
      this.filterStatus = this.statusList
    } else {*/
      var minOrder = 9999;
      for( var s in this.statusList ) {
        if( this.statusList[s].is_checked == 'Yes' && this.statusList[s].order < minOrder ) {
          minOrder = this.statusList[s].order;
        }
        /*if( this.statusList[s].is_hybris == 'Yes' && this.statusList[s].order < minOrder ) {
          minOrder = this.statusList[s].order;
        }*/
      }

      for( var s in this.statusList ) {
        var statusDeps = this.statusList[s].department.split(',');
        var statusRoles = this.statusList[s].roles.split(',');
        if( statusRoles.indexOf(String(this.objAuthorize.roles[0])) != -1 && statusDeps.indexOf(String(this.globalModalParams.departmentId)) != -1 ) {
          /*if( this.statusList[s].is_checked == 'Yes' || this.statusList[s].is_hybris == 'Yes' ) {
            // this.filterStatus.push({ disabled: true, id: this.statusList[s].id, 'description':this.statusList[s].description});
          } else {
            this.filterStatus.push({ disabled: false, id: this.statusList[s].id, 'description':this.statusList[s].description});
          }*/
          if( this.statusList[s].order < minOrder ) {
            this.filterStatus.push({ disabled: false, id: this.statusList[s].id, 'description':this.statusList[s].description});
          }
        }
      }
    // }
  }
}
</script>

<style scoped>

</style>
